export function addOpacity(hex: string, alpha: number): string {
  if (!hex) return null
  // Remove leading "#" if present
  hex = hex.replace(/^#/, '')

  // Expand shorthand like "000" → "000000"
  if (hex.length === 3) {
    hex = hex.split('').map(ch => ch + ch).join('')
  } else if (hex.length > 6) {
    hex = hex.slice(0, 6)
  }

  if (hex.length !== 6) {
    throw new Error(`Invalid HEX color: ${hex}`)
  }

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const getTopicBackground = (color:string) => addOpacity(color, 0.1)
